import { render, staticRenderFns } from "./BaseCurrencyInfo.vue?vue&type=template&id=4d6563ba"
import script from "./BaseCurrencyInfo.vue?vue&type=script&lang=ts"
export * from "./BaseCurrencyInfo.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports